import { NgModule } from '@angular/core';
import { TopIconCardComponent } from './top-icon-card.component';
import {
  TopIconCardBodyDirective,
  TopIconCardFooterDirective,
  TopIconCardHeaderDirective,
  TopIconCardIconDirective,
} from './top-icon-card-sections';
import { CommonModule } from '@angular/common';
import { LoadingOverlayModule } from '../loading-overlay';

const publicApi = [
  TopIconCardComponent,
  TopIconCardIconDirective,
  TopIconCardHeaderDirective,
  TopIconCardBodyDirective,
  TopIconCardFooterDirective,
];

@NgModule({
  imports: [CommonModule, LoadingOverlayModule],
  declarations: [...publicApi],
  exports: [...publicApi],
})
export class TopIconCardModule {}
